import LocomotiveScroll from "./locomotive-scroll.min";
let scroller;
let scrollPos;

var mainHeader = $('.cd-auto-hide-header'),
	secondaryNavigation = $('.cd-secondary-nav'),
	//this applies only if secondary nav is below intro section
	belowNavHeroContent = $('.sub-nav-hero'),
	headerHeight = mainHeader.height();
let scroll;
//set scrolling variables
var scrolling = false,
	previousTop = 0,
	currentTop = 0,
	currentScroll,
	scrollDelta = 10,
	scrollOffset = 100;



let scrollContainer = document.querySelector("[data-scroll-container]");
// window.addEventListener('load', (event) => {
// 	if(scrollContainer){

// 		window.ScrollInit()

// 	}
//   });


autohideheader();


function autohideheader() {
	if ($('.wth_menu_theme_2').length) {
		mainHeader.addClass('menu_theme_2');
		$('footer').css('paddingBottom', 0);

	}
	//

	jQuery(document).ready(function($) {
		$('body').css('paddingTop', $('.navigation').innerHeight());
		$('footer').css('paddingBottom', $('.navigation').innerHeight());


		if ($('.wth_menu_theme_2').length) {
			$('body').addClass('wth_menu_theme_2').css('paddingTop', 0);
			mainHeader.addClass('menu_theme_2');
			$('footer').css('paddingBottom', 0);

		}

		

		function menuShow() {
			$('body').addClass('body-in-blur');
			scroll.stop();

		}

		function menuHide() {

			$('body').removeClass('body-in-blur');
			scroll.start();

		}
		$(".header .dropdown").on("show.bs.dropdown", function (event) {
			// var x = $(event.relatedTarget).text(); // Get the text of the element
			// alert(x);
			menuShow();


			//mainHeader.addClass('styled');

		});

		$(".header .dropdown").on("hide.bs.dropdown", function (event) {

			menuHide();

		});

		$(".navbar-toggler").click(function () {
			$(this).toggleClass('active');
			if ($(this).hasClass('active')) {
				menuShow();
				mainHeader.addClass('styled');

			} else {
				menuHide();

			}
			$('body').toggleClass('menu-toggle');
			

		})
		$(".close-menu").click(function () {
			$(".navbar-toggler").removeClass('active');
			$('body').removeClass('menu-toggle');
			menuHide();

		})


		window.initializeScroll = function () {
			
			scroll = new LocomotiveScroll({
				el: document.querySelector('[data-scroll-container]'),
				smooth: true,
				// getSpeed: true,
				// getDirection: true,
				useKeyboard: true,
				smartphone: {
					breakpoint: 767,

					smooth: false,
					useKeyboard: false,

					// inertia: 0.8,
					// getDirection: true,
				  },
				  tablet: {
					breakpoint: 992,

					smooth: false,
					useKeyboard: false,
				  },
			});


			currentScroll = scroll;

			//ON SCROLL EVENTS
			currentScroll.on('scroll', (instance) => {

				let windowWidth = window.innerWidth;
				let windowHeight = window.innerHeight;

				scrollPos = instance.scroll.y;
				if (!scrolling) {
					scrolling = true;
					(!window.requestAnimationFrame) ?
					setTimeout(autoHideHeader, 250): requestAnimationFrame(autoHideHeader);

				}
			})




		}
		if (scrollContainer) {

			window.initializeScroll()

		}


		if(($('.has-scroll-init').length>0) && ($('.videoIframe').length>0)  && (!$('.videoIframe').hasClass('d-none')>0) && (window.innerWidth>992)){
			$('.videoIframe iframe').addClass('pointer-none');
			$('.videoIframe').click(function(){
				$('.videoIframe').addClass('done')
				$('.videoIframe iframe').removeClass('pointer-none');
				$('.videoIframe iframe').src += "?autoplay=1"
		
		
			})
			
		
		}
		$('.hamburger').click(function () {
			$('.hamburger').toggleClass('is-active');
			$('.menu_accordion').toggleClass('is-active');

		})



		mainHeader.on('click', '.nav-trigger', function (event) {
			// open primary navigation on mobile
			event.preventDefault();
			mainHeader.toggleClass('nav-open');
		});

		if ((currentTop = previousTop)) { //this has been added by Elhamy
			mainHeader.removeClass('is-shown'); //this has been added by Elhamy
			//console.log('its at top') //this has been added by Elhamy
		} //this has been added by Elhamy



		$(window).on('scroll', function () {
			if (!scrolling) {
				scrolling = true;
				(!window.requestAnimationFrame) ?
				setTimeout(autoHideHeader, 250): requestAnimationFrame(autoHideHeader);

			}
		});

	
		function autoHideHeader() {
			var currentTop = scrollPos;

			(belowNavHeroContent.length > 0) ?
			checkStickyNavigation(currentTop) // secondary navigation below intro
				: checkSimpleNavigation(currentTop);

			previousTop = currentTop;
			scrolling = false;
		}
		//console.log('previousTop1', previousTop)
		//console.log('currentTop1', currentTop)

		function checkSimpleNavigation(currentTop) {
			//there's no secondary nav or secondary nav is below primary nav
			if (previousTop - currentTop > scrollDelta) {
				//if scrolling up...
				mainHeader.removeClass('is-hidden');
				mainHeader.addClass('is-shown'); //this has been added by Elhamy

				//console.log('scrollingup')
				//console.log('previousTop2', previousTop)
				//console.log('currentTop2', currentTop)
				addStyle();
			} else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
				//if scrolling down...
				mainHeader.addClass('is-hidden');
				mainHeader.removeClass('is-shown'); //this has been added by Elhamy

				// for hamburger menu
				$('.hamburger').removeClass('is-active');
				// for accordion menu
				$('.menu_accordion').removeClass('is-active');

				if (mainHeader.hasClass('nav-open')) { //this has been added by Elhamy
					mainHeader.removeClass('nav-open'); //this has been added by Elhamy

				} //this has been added by Elhamy
				//console.log('scrollingdown')
				//console.log('previousTop3', previousTop)
				//console.log('currentTop3', currentTop)
				addStyle();
			}
		}

		function addStyle() {
			var logo = $('.logo a img');
			var logoimg = $('.logo a img').attr('src');
			//console.log('logoimg', logoimg)
			if ((previousTop + currentTop > 500)) {
				mainHeader.addClass('styled');


				//  logoimg = logo.attr('src', logo_colored);
			} else {
				mainHeader.removeClass('styled');
				// logoimg = logo.attr('src', logo_white);
			}
		}

		function checkStickyNavigation(currentTop) {
			//secondary nav below intro section - sticky secondary nav
			var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();

			if (previousTop >= currentTop) {
				//if scrolling up... 
				if (currentTop < secondaryNavOffsetTop) {
					//secondary nav is not fixed
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.removeClass('fixed slide-up');
					belowNavHeroContent.removeClass('secondary-nav-fixed');
				} else if (previousTop - currentTop > scrollDelta) {
					//secondary nav is fixed
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.removeClass('slide-up').addClass('fixed');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				}

			} else {
				//if scrolling down...	
				if (currentTop > secondaryNavOffsetTop + scrollOffset) {
					//hide primary nav
					mainHeader.addClass('is-hidden');
					mainHeader.removeClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.addClass('fixed slide-up');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				} else if (currentTop > secondaryNavOffsetTop) {
					//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
					mainHeader.removeClass('is-hidden');
					mainHeader.addClass('inscroll-top'); //this has been added by Elhamy
					secondaryNavigation.addClass('fixed').removeClass('slide-up');
					belowNavHeroContent.addClass('secondary-nav-fixed');
				}

			}
		}
	});

	window.UpdateMyScroll=function(){
		console.log('resize')
		scroll.update();
	
	}

	window.scrollTobyMyscroll=function(target){
		scroll.scrollTo(target);

	
	}





   var myInterval = setInterval(UpdateMyScroll, 1000);


	window.addEventListener('load', (event) => {
		if($('.has-scroll-init').length>0){
			window.UpdateMyScroll();
			clearInterval(myInterval);

		}
	

	})
}





window.reinitMyscroll = function (target) {

	if ($('.has-scroll-init').length > 0) {
		window.UpdateMyScroll();
		//scroll.scrollTo(scrollContainer);
		$('html').removeClass('has-scroll-init');
		currentScroll.destroy();
		$('.c-scrollbar').remove();
		setTimeout(function () {
			window.initializeScroll();
			setTimeout(() => {
				window.UpdateMyScroll()
	
			}, 750);
		}, 400);
		
	
	}


}

window.addEventListener('resize', function () {
	if(window.innerWidth>992){
		window.reinitMyscroll();

		
		
	}

})